module.exports = __webpack_public_path__ + "img/12_46.39981ae9.png";